import { render, staticRenderFns } from "./PolicyBlackcard.vue?vue&type=template&id=761216d0&scoped=true"
import script from "./PolicyBlackcard.vue?vue&type=script&lang=ts"
export * from "./PolicyBlackcard.vue?vue&type=script&lang=ts"
import style0 from "./PolicyBlackcard.vue?vue&type=style&index=0&id=761216d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761216d0",
  null
  
)

export default component.exports